import React, { useState } from 'react';
import { InputContainer, InputLabel, TabBody } from './styles';

import { SINGLE_SIGN_ON_SETTINGS as trans } from './TranslationValues';
import { Input, Icon, Tooltip, message, Switch, Popconfirm } from 'antd';
import { withTranslation } from 'react-i18next';
import ActionButton from '../../components/ActionButton';

const NAMESPACE = ['SINGLE_SIGN_ON_SETTINGS'];

const OIDCPanel = ({
  t,
  isVisible,
  onSave,
  oidcConfig,
  setConfigModal,
  directoryEnabled = false,
  handleEnableDirectory,
  currentSavedConfig
}) => {
  const [defaultOidcConfig, setDefaultOidcConfig] = useState({});
  const [loading, setLoading] = useState(false);
  const [editOidc, setEditOidc] = useState(false);
  const [togglePopconfirm, setTogglePopconfirm] = useState(false);

  const tooltipContent = (
    <div style={{ fontSize: '12px' }}>
      You can use any of the following as your tenant name or identifier:
      <ul style={{ margin: 0, paddingLeft: '20px', listStyle: 'disc', textAlign: 'left' }}>
        <li>Email domain</li>
        <li>Organization ID or slug</li>
        <li>Team ID or slug</li>
        <li>Other unique identifiers</li>
      </ul>
    </div>
  );

  const handleConfigChange = ({ target: { name, value } }) => {
    setDefaultOidcConfig(prev => {
      console.log(prev);
      return { ...prev, [name]: value };
    });
  };

  const checkOidcConfig = () => {
    if (
      !defaultOidcConfig.tenantName ||
      !defaultOidcConfig.clientId ||
      !defaultOidcConfig.clientSecret ||
      !defaultOidcConfig.discoveryUrl
    ) {
      return message.warning(
        'Tenant name, Client Id, Client Secret and discovery URL are required',
      );
    }
    const method = currentSavedConfig === 'saml' ? 'put' : editOidc ? 'put' : 'post';
    setLoading(true);
    onSave(
      method,
      {
        tenant: defaultOidcConfig.tenantName,
        oidcClientId: defaultOidcConfig.clientId,
        oidcClientSecret: defaultOidcConfig.clientSecret,
        oidcDiscoveryUrl: defaultOidcConfig.discoveryUrl,
      },
      () => {
        setEditOidc(false);
        setLoading(false);
      },
    );
  };

  const handleEditSaml = () => {
    setDefaultOidcConfig({
      tenantName: oidcConfig.oidcTenant,
      clientId: oidcConfig.oidcClientId,
      clientSecret: oidcConfig.oidcClientSecret,
      discoveryUrl: oidcConfig.discoveryUrl,
    });
    setEditOidc(true);
  };

  return (
    <TabBody isVisible={isVisible}>
      {oidcConfig?.oidcTenant && oidcConfig?.oidcClientId && oidcConfig?.oidcClientSecret && oidcConfig?.discoveryUrl && !editOidc ? (
        <>
          <InputContainer full>
            <InputLabel>{t(trans.SSO_TENANT_NAME.key, trans.SSO_TENANT_NAME.value)}</InputLabel>
            <Input size="large" disabled value={oidcConfig.oidcTenant} autoComplete={false} />
          </InputContainer>
          <InputContainer full>
            <InputLabel>Client ID</InputLabel>
            <Input size="large" disabled value={oidcConfig.oidcClientId} autoComplete={false} />
          </InputContainer>
          <InputContainer full>
            <InputLabel>Client Secret</InputLabel>
            <Input.Password size="large" disabled value={oidcConfig.oidcClientSecret} autoComplete={false} />
          </InputContainer>
          <InputContainer full>
            <InputLabel>Discovery URL</InputLabel>
            <Input size="large" disabled value={oidcConfig.discoveryUrl} autoComplete={false} />
          </InputContainer>
          <div style={{ marginTop: '28px' }}>
            <ActionButton label={'Edit OIDC Configurations'} onClick={handleEditSaml} />
          </div>
          <div style={{ margin: '28px' }}>
            <Popconfirm
              title={
                'Are you sure you want to enable Directory Sync? Once enabled, it cannot be disabled.'
              }
              okText={'Enable'}
              cancelText={'Cancel'}
              placement="top"
              trigger="click"
              visible={togglePopconfirm}
              onConfirm={() => {
                handleEnableDirectory(true);
                setTogglePopconfirm(false);
              }}
              onCancel={() => setTogglePopconfirm(false)}
              overlayStyle={{ width: 350 }}
            >
              <Switch
                className="ds-switch"
                checkedChildren="Directory Sync Enabled"
                unCheckedChildren="Directory Sync Disabled"
                checked={directoryEnabled || false}
                disabled={directoryEnabled || false}
                onChange={checked => setTogglePopconfirm(true)}
              />
            </Popconfirm>
          </div>
        </>
      ) : (
        <>
          <InputContainer full>
            <InputLabel>
              {t(trans.SSO_TENANT_NAME.key, trans.SSO_TENANT_NAME.value)}{' '}
              <Tooltip title={tooltipContent}>
                <Icon type="info-circle" />
              </Tooltip>
            </InputLabel>
            <Input
              name="tenantName"
              size="large"
              onChange={handleConfigChange}
              defaultValue={oidcConfig?.oidcTenant || ''}
              autoComplete={false}
            />
            <p className="help-text">
              Unique identifier for the tenant to which this SSO connection is linked
            </p>
          </InputContainer>
          <InputContainer full>
            <InputLabel>Client ID</InputLabel>
            <Input
              name="clientId"
              size="large"
              onChange={handleConfigChange}
              defaultValue={oidcConfig?.oidcClientId || ''}
              autoComplete={false}
            />
            <p className="help-text">The Client ID provided by your Identity Provider (IdP)</p>
          </InputContainer>
          <InputContainer full>
            <InputLabel>Client Secret</InputLabel>
            <Input.Password
              name="clientSecret"
              size="large"
              onChange={handleConfigChange}
              defaultValue={oidcConfig?.oidcClientSecret || ''}
              autoComplete={false}
            />
            <p className="help-text">The Client Secret provided by your Identity Provider (IdP)</p>
          </InputContainer>
          <InputContainer full>
            <InputLabel>Discovery URL</InputLabel>
            <Input
              name="discoveryUrl"
              size="large"
              onChange={handleConfigChange}
              defaultValue={oidcConfig?.discoveryUrl || ''}
              autoComplete={false}
            />
            <p className="help-text">The OIDC discovery endpoint URL from your Identity Provider</p>
          </InputContainer>
          <div style={{ margin: '20px' }}>
            <ActionButton
              label={editOidc ? 'Update OIDC Configurations' : 'Configure OIDC'}
              onClick={checkOidcConfig}
              loading={loading}
            />
          </div>
        </>
      )}
      <div className="config-link-container">
        Share the&nbsp;
        <span className="config-link" onClick={() => setConfigModal('oidc')}>
          OIDC Configuration
        </span>
        {directoryEnabled && ` & `}
        {directoryEnabled && (
          <span className="config-link" onClick={() => setConfigModal('directory')}>
            Directory Configuration
          </span>
        )}
        &nbsp;information with Your Identity Provider (IdP){' '}
      </div>
    </TabBody>
  );
};

export default withTranslation(NAMESPACE)(OIDCPanel);
